import {
  StylesDerivedNativeActionNames,
  StylesDerivedNativeActions,
} from '@wix/editor-platform-host-integration-apis';
import borderAction from './border';
import { GlobalDesignAction } from './types';
import cornerAction from './corner';
import fillAction from './fill';
import globalColorsAction from './globalColors';
import shadowAction from './shadow';
import spacingAction from './spacing';
import textAction from './text';

const actions: Record<StylesDerivedNativeActionNames, GlobalDesignAction> = {
  [StylesDerivedNativeActions.borderStyles]: borderAction,
  [StylesDerivedNativeActions.cornerStyles]: cornerAction,
  [StylesDerivedNativeActions.fillStyles]: fillAction,
  [StylesDerivedNativeActions.globalColorsStyles]: globalColorsAction,
  [StylesDerivedNativeActions.shadowStyles]: shadowAction,
  [StylesDerivedNativeActions.spacingStyles]: spacingAction,
  [StylesDerivedNativeActions.textStyles]: textAction,
};

export default actions;
